<template>
  <v-row class="pa-3">
    <v-col class="text-center"
           cols="12">
      <span :class="`main-text ${headerFontSize}`">
        <b>Zadzwoń</b>
      </span>
      <br>
      <a style="color: black;"
         :class="`${subheaderFontSize}`"
         href="tel:+48123409449"
         aria-label="+48123409449">
        <v-icon style="margin-right: 4px;"
                color="primary">mdi-phone-in-talk</v-icon>+48 12 34 09 449
      </a>
      <br>
      <span>(pracujemy w dni robocze w godz. 8:00 - 16:00)</span>
    </v-col>
  </v-row>
</template>

<script>
import VueOnGeoGlobalMixin from "./vue-ongeo-global-mixin.js";

export default {
  name: "vue-ongeo-call-panel",
  mixins: [VueOnGeoGlobalMixin]
};
</script>
